/*
 * @Description:
 * @Date: 2022-04-18 14:15:26
 */
import tinymce from './src/index.vue';
export default tinymce;
